/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import TTDError from '../utils/ttdError'
import { getSessionToken } from './auth'

/**
 * @async
 * @description
 * @param {string} uri
 * @returns {string}
 */
export const downloadSecureDocument = async (uri: string, forceDownload?: boolean) => {
    try {
        const token = await getSessionToken()
        const result = await axios.get(`${uri}`, {
            headers: {
                'X-Session-Token': token,
            },
            responseType: 'blob',
        })
        if (forceDownload) {
            const fileUrl = URL.createObjectURL(result.data)
            const a = document.createElement('A')
            a.setAttribute('href', fileUrl)
            a.setAttribute('download', result.headers['content-disposition'].match(/filename="([^"]+)"/)[1])
            document.body.appendChild(a)
            a.click()
            a.remove()
        }
        return result.data
    } catch (error) {
        throw new TTDError('Impossible de récupérer le document', true)
    }
}
